import './index.scss';
import React from 'react';
import { Icon } from 'semantic-ui/semantic-ui-imports';

interface Props {
  onClick: (ev: React.MouseEvent) => void;
  icon: string;
  disabled?: boolean;
}

const classId = 'icon-button';

export default ({ onClick, icon, disabled }: Props) => (
  <div
    className={`${classId}${disabled ? ` ${classId}--disabled` : ''}`}
    onClick={(ev) => !disabled && onClick(ev)}
  >
    <Icon name={icon} className={`${classId}__icon`} />
  </div>
);
